import styled from "styled-components";

const LoginRegisterWrapper = styled.div`
  /* padding-bottom: 10px; */

  .ahp-title {
    margin-bottom: 16px;
    text-align: center;
    text-transform: uppercase;
    font-weight: 900;
  }

  .login-btn,
  .ok-btn {
    width: 100%;
    border: none;
    background-color: #5382a4;
    color: white;
    height: 30px;
    cursor: pointer;
  }

  .new-user {
    display: table;
    margin: 8px auto;
    padding-bottom: 12px;
    font-size: 1rem;
    color: #5382a4;
    /* text-transform: uppercase; */
    cursor: pointer;
  }

  .ant-form.ant-form-horizontal {
    margin: 16px;
    text-align: center;
  }

  .result-container {
    margin: 16px;
    text-align: center;
    padding-bottom: 16px;
  }

  .ahp-notification {
    width: 100%;
    text-align: center;
    font-size: 1.4rem;
    padding: 16px;
  }

  .google-btn {
    margin: 16px;
  }

  .ahp-facebook-btn,
  .ahp-google-btn {
    background-color: white;
    border: 1px solid lightgrey;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    column-gap: 10px;
    cursor: pointer;
  }

  .ahp-federated-login-btns {
    display: flex;
    justify-content: space-around;
  }
`;

export { LoginRegisterWrapper };
